import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListSubheading, List } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';
import { convertToKebabCase } from 'client/common/utils/string-utils.ts';
import { EstimatesFilter } from './estimates.filter';

export const EstimatesList = ({ items, filter, setFilter }) => {
  const { t } = useTranslation();
  const itemsWithTestId = items.map((item) => ({
    ...item,
    testId: `offset-wells-list-${convertToKebabCase(item.name)}-item`,
  }));
  return (
    <>
      <EstimatesFilter filter={filter} setFilter={setFilter} />
      <ListSubheading
        testId="offset-wells-list-subheading"
        item={{ name: t(translations.estimate), metaCount: items.length }}
      />
      <List testId="offset-wells-list" list={{ items: itemsWithTestId }} noHeader />
    </>
  );
};
